'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertCircleOutline } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useHasStayWithNoAlternatives } from '~/components/TripOverview/hooks/useHasStayWithNoAlternatives';
import { useTripOverviewSummary } from '~/components/TripOverview/hooks/useTripOverviewSummary';
import styles from '../TripOverviewPage.module.css';
export const UNAVAILABLE_BANNER_ID = 'overview-unavailable-banner';
type TripOverviewUnavailableBannerProps = {
  id?: string;
};
export const TripOverviewUnavailableBanner = t0 => {
  const $ = _c(20);
  const {
    id
  } = t0;
  const t = useTranslations("journey");
  const hasStayWithNoAlternatives = useHasStayWithNoAlternatives();
  const {
    isStartDateInPast,
    isReadOnly
  } = useTripOverviewSummary();
  if (!isStartDateInPast && !hasStayWithNoAlternatives) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("overview_unavailable_accommodation_body");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let body = t1;
  if (isReadOnly) {
    let t2;
    if ($[2] !== t) {
      t2 = t("overview_unavailable_locked_body");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    body = t2;
  } else {
    if (isStartDateInPast) {
      let t2;
      if ($[4] !== t) {
        t2 = t("overview_dates_past_body");
        $[4] = t;
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      body = t2;
    }
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className={styles.unavailableBannerIcon}><AlertCircleOutline decorative={true} size="scale" /></span>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isStartDateInPast || $[8] !== t) {
    t3 = isStartDateInPast ? t("overview_dates_past_heading") : t("overview_unavailable_accommodation_heading");
    $[7] = isStartDateInPast;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <h3 className={styles.unavailableBannerHeading}>{t3}</h3>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== body) {
    t5 = <p className={styles.unavailableBannerBody}>{body}</p>;
    $[12] = body;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className={styles.unavailableBannerText}>{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== id || $[18] !== t6) {
    t7 = <aside id={id} className={styles.unavailableBanner}>{t2}{t6}</aside>;
    $[17] = id;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};